import React, { useEffect, useState } from 'react';
import "./Category.css";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
// import { GetFeedbackPage, Getblinkit } from '../apiconfig/authService';
import { Pagination } from "rsuite";
import 'rsuite/dist/rsuite.min.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
function Amazon(props) {
    const navigate = useNavigate();
    const { decodedToken, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const message = props.message;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [categoriesData, setCategoriesData] = useState([]);
    const [feedbacksData, setFeedbacksData] = useState([]);
    const [totalFeedbacks, setTotalFeedbacks] = useState();
    const [pincode, setPincode] = useState([]);

    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [totalCategories, setTotalCategories] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [recordIdToDelete, setRecordIdToDelete] = useState('');
    const [refetchData, setRefetchData] = useState(false);

    const handlePerPageRecordsChange = (e) => {
        setItemsPerPage(e.target.value);
        setPageCount(1);
    };

    console.log(feedbacksData);

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const queryParams = {
                        page,
                        itemsPerPage,
                        search,
                        startDate: startDate ? startDate.toISOString().split('T')[0] : null,
                        endDate: endDate ? endDate.toISOString().split('T')[0] : null,
                    };

                    // const feedbacksData = await Getblinkit(queryParams, localStorage.getItem('accessToken'));
                    const feedbacksData = await axios.get(
                        "https://scrapbackend.pikeazy.in/store/getamazon",
                        { params: queryParams }
                    );
                    setFeedbacksData(feedbacksData.data.items);
                    console.log("eedbacksData.data.items??????", feedbacksData.data.items)
                    console.log("eedbacksData.data.items??????", feedbacksData.data.items)
                    setPincode(feedbacksData.data.items.pincodeinfo)
                    setPageCount(Math.ceil(feedbacksData.data.pagination.pageCount));
                    setTotalFeedbacks(feedbacksData.data.pagination.count);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, [page, itemsPerPage, refetchData]);

    const handleViewFeedbackClick = (feedbackid) => {
        navigate(`/viewFeedback/${feedbackid}`);
    };

    const handlePrevious = () => {
        setPage((p) => {
            if (p === 1) return p;
            return p - 1;
        });
    };
    const handleNext = () => {
        setPage((p) => {
            if (p === pageCount) return p;
            return p + 1;
        });
    };

    const handleSearchBoxSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setRefetchData(!refetchData)
    };

    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={"de"} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={"menu"} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Amazon Management<br /><small className="text-primary h6 fw-bold">Total counts {totalFeedbacks}</small></h1>
                </div>
                <div className="collapse mb-4" id="filter">
                    <div className="card card-body">
                        <form className="filterForm" action="/">
                            <div className="row">
                                <div className="col-lg-12 mb-2">
                                    <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatBilling" aria-label="Billing">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatBilling">Billing</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatStatus" aria-label="Status">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatStatus">Status</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <button type="submit" className="btn btn-primary btn-lg save-btn text-uppercase w-100">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="searchList row">
                    <div className="displayRecord d-flex align-items-center col-lg-4 mb-2">
                        <span className="h6 mb-0">Display Records</span>
                        <select className="form-select" value={itemsPerPage} onChange={handlePerPageRecordsChange}>
                            <option defaultValue="10">10</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>

                    <div className="col-lg-4 mb-2">
                        <form onSubmit={handleSearchBoxSubmit}>
                            <div className="row">
                                <div className="col-lg-4">
                                    <label>Start Date</label>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        className="form-control"
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select start date"
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label>End Date</label>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        className="form-control"
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="Select end date"
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <button type="submit" className="btn btn-primary mt-4">Filter</button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="searchForm d-flex justify-content-end col-lg-4 mb-2">
                        <form className="sForm" onSubmit={handleSearchBoxSubmit}>
                            <input type="text" onChange={(event) => { setSearch(event.target.value) }} className="form-control form-control-lg w-100" id="s" placeholder="Search" />
                        </form>
                    </div>
                </div>

                {message && <div className="alert alert-primary" role="alert">{message}</div>}
                <div className="table-responsive">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '50px' }} scope="col" width="45" align="center">
                                    <div className="selectAll">
                                        <input className="form-check-input" type="checkbox" />
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col" width="80">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">SR.</span>
                                        <button className="filtBtn idFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Productid</span>
                                        <button className="filtBtn fNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Amazon Id</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Code</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Message</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '120px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Pincode</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '250px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">AmazonPrice</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '250px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">AmazonQuantity</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Availiblity
                                        </span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">IsScrape</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>

                                {/* <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '170px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Created Date</span>
                                        <button className="filtBtn statusFilter"></button>
                                    </div>
                                </th> */}
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '170px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Modified Date</span>
                                        <button className="filtBtn emailFilter"></button>
                                    </div>
                                </th>
                                {/* <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Created By</span>
                                        <button className="filtBtn emailFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Modified By</span>
                                        <button className="filtBtn emailFilter"></button>
                                    </div>
                                </th> */}
                                {/* <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Action</span>
                                    </div>
                                </th> */}
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {feedbacksData.map((item, index) => (
                                <tr key={item?._id}>
                                    <td><input className="form-check-input" type="checkbox" /></td>
                                    <td>{index + 1}</td>
                                    <td>{item?.productid}</td>
                                    <td>{item?.
                                        amazonid
                                    }</td>
                                    {item.pincodeinfo.map((pincodeItem, pIndex) => (
                                        <React.Fragment key={pIndex}>
                                            <td>{pincodeItem?.code}</td>
                                            <td>{pincodeItem?.message}</td>
                                            <td>{pincodeItem?.pincode}</td>
                                            <td>{pincodeItem?.amazonprice
                                            }</td>
                                            <td>{pincodeItem?.amazonquantity}</td>
                                            <td>{pincodeItem?.availiblity}</td>
                                            <td>{pincodeItem?.isScrape ? 'true' : 'false'}</td> {/* Render as Yes/No */}
                                        </React.Fragment>
                                    ))}
                                    {/* <td>{formatUTCDate(item?.createddate)}</td> */}
                                    <td>{formatUTCDate(item?.modifieddate)}</td>
                                    {/* <td>
                                        <div className="d-grid gap-2 d-md-block">
                                            <button type="button" onClick={() => { handleViewFeedbackClick(item._id) }} className="actBtn viewBtn">
                                                <Icon className="eye" icon={eye} size={18} />
                                                <span className="toolTip">Preview</span>
                                            </button>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="resultList pt-3 border-top">
                    <div className="row">
                        <div className="d-flex justify-content-between displayRecord col mt-2">
                            {totalFeedbacks === 0 ? (
                                <div style={{ margin: "auto" }}>No Data found.</div>
                            ) : (
                                <div>
                                    Showing {(page - 1) * itemsPerPage + 1} -{" "}
                                    {totalFeedbacks < itemsPerPage * page
                                        ? totalFeedbacks
                                        : itemsPerPage * page}{" "}
                                    of {totalFeedbacks} entries.
                                </div>
                            )}
                            {/* Render pagination only if totalFeedbacks is greater than 0 */}
                            {totalFeedbacks > 0 && (
                                <div>
                                    <Pagination
                                        prev
                                        last
                                        next
                                        first
                                        size="sm"
                                        ellipsis
                                        boundaryLinks
                                        onSelect={setPage}
                                        limit={itemsPerPage}
                                        onChangeLimit={setItemsPerPage}
                                        layout={["pager", "skip"]}
                                        pages={pageCount}
                                        total={totalFeedbacks}
                                        maxButtons={5}
                                        activePage={page}
                                        onChangePage={(page) => {
                                            setPage(page);
                                        }}
                                    />
                                </div>
                            )}
                            {/* Pagination End */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Amazon;
